/* istanbul ignore file */
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background: #D7F4FE;
  border-radius: 8px;
  padding: 8px;
  margin-bottom: 16px;
`;

const Text = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: #1E194B;
  margin: 0;
`;

const PatientInfo: React.FC = () => (
  <Container id="patient-info-container">
    <Text>
      Before you start, you must inform the patient you are using a tool to help transcribe and summarise the consultation to assist with note-taking.
    </Text>
  </Container>
);

export default PatientInfo;
